import userAdmin from './userAdmin'
let defaults = {
  userAdmin
}
export default defaults
